import { FC } from 'react';
import {
    useTranslate,
    ReferenceManyField,
    Datagrid,
    SimpleList,
    DateField,
    NumberField,
    Pagination,
    PaginationProps,
} from 'react-admin';
import {
    makeStyles,
    createStyles,
    Theme,
    Grid,
    useMediaQuery,
    Typography,
} from '@material-ui/core';
// import collections from "../collections"
import { dateLocales, currencyFormatter, defaultDateOptions } from '../utils/formatters';
import getCollectionsTypes from '../collections/CollectionsTypes'
import ColoredChipField from '../components/ColoredChip';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        fixed_fee: {},
        amount: { fontWeight: 'bold' },
        dataGrid: {
            // width: '50%'
        }

    })
)

const collectionsTypes = getCollectionsTypes()

const CollectionsTable: FC<{}> = (props) => {
    const translate = useTranslate()
    const classes = useStyles()

    const limit = 10

    const isMedium = useMediaQuery<Theme>(theme =>
        theme.breakpoints.down('md')
    );
    const isSmall = useMediaQuery<Theme>(theme =>
        theme.breakpoints.down('sm')
    );


    const CustomPagination = (props: JSX.IntrinsicAttributes & PaginationProps) =>
        <Pagination rowsPerPageOptions={[10, 25, 50, 100]} {...props} />;


    return <Grid item xs={12}>
        <Typography variant="h6" gutterBottom>{`${translate("resources.financings.fields.collections")}`}</Typography>
        <ReferenceManyField
            perPage={limit}
            pagination={<CustomPagination/>}
            sort={{ field: 'collected_at', order: 'DESC' }}
            reference="collections"
            target="financing_id"
        >
            {isSmall ? // Change of responsive design
                <SimpleList
                    primaryText={record => `${(record.id as string).slice(0, 4)}...${(record.id as string).slice(-4)}`}
                    tertiaryText={record => `Amount: ${currencyFormatter().format(record.repayment_amount)}`}
                    secondaryText={record => `Rem. Balance: ${currencyFormatter().format(record.remaining_balance)}`}
                    linkType={record => record.canEdit ? "edit" : "show"}
                // leftIcon={record => <collections.icon />}
                // rowStyle={postRowStyle}
                />
                :
                <Datagrid className={classes.dataGrid} optimized rowClick="edit">
                    <NumberField source="id" />
                    {!isMedium && <DateField source="collected_at" locales={dateLocales} options={defaultDateOptions} />}
                    <NumberField
                        source="repayment_amount"
                        className={classes.amount}
                        locales="en-US"
                        options={currencyFormatter().resolvedOptions()}
                    />
                    <NumberField
                        source="remaining_balance"
                        className={classes.amount}
                        locales="en-US"
                        options={currencyFormatter().resolvedOptions()}
                    />
                    <ColoredChipField source="type" choices={collectionsTypes} />
                </Datagrid>
            }
        </ReferenceManyField>
    </Grid>
}


export default CollectionsTable